import React, { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import moment from "moment";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import CustomTable from "../../../components/table/table";
import { admin_login_logs_list } from "../admin.api";
import * as XLSX from "xlsx";
import "./style.css";

const getStatusInfo = (status) => {
  const statusMap = {
    success: {
      label: "Success",
      class: "successs",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      )
    },
    failed: {
      label: "Failed",
      class: "danger",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
      )
    },
    failure: {
      label: "Failed",
      class: "danger",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
      )
    },
  };
  const defaultIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="16" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
  );
  return statusMap[status] || {
    label: status?.charAt(0).toUpperCase() + status?.slice(1),
    class: "secondary",
    icon: defaultIcon
  };
};

export default function LoginLogs(props) {
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    search: "",
    status: "",
    user_type: "",
  });

  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const fetchLogs = () => {
    setIsActive(true);
    admin_login_logs_list({
      page,
      per_page: perPage,
      ...filters
    })
      .then((res) => {
        if (res?.success) {
          let tdata = res.data.data || [];
          tdata.forEach((item, index) => {
            item["slno"] = (page - 1) * perPage + index + 1;
          });
          setData(tdata);
          setTotalPages(res.data.last_page || 1);
        }
        setIsActive(false);
      })
      .catch((error) => {
        console.error("Error fetching login logs:", error);
        setSnackMessage("Failed to load logs");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  useEffect(() => {
    fetchLogs();
  }, [page, perPage, filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
    setPage(1);
  };

  const handlePerPageChange = (e) => {
    setPerPage(parseInt(e.target.value));
    setPage(1);
  };

  const renderPagination = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    if (start > 1) {
      pages.push(
        <button key={1} className="btn btn-sm btn-outline-primary" onClick={() => setPage(1)}>1</button>
      );
      if (start > 2) pages.push(<span key="start-dots" className="px-1 text-primary">...</span>);
    }

    for (let i = start; i <= end; i++) {
      pages.push(
        <button
          key={i}
          className={`btn btn-sm ${page === i ? "btn-primary text-white" : "btn-outline-primary"}`}
          onClick={() => setPage(i)}
        >
          {i}
        </button>
      );
    }

    if (end < totalPages) {
      if (end < totalPages - 1) pages.push(<span key="end-dots" className="px-1 text-primary">...</span>);
      pages.push(
        <button key={totalPages} className="btn btn-sm btn-outline-primary" onClick={() => setPage(totalPages)}>{totalPages}</button>
      );
    }

    return pages;
  };

  const handleView = (row) => {
    props.history.push(`/login-logs/${row.id}`);
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      fetchLogs();
    }
  };

  const downloadExcel = () => {
    if (!data.length) {
      setSnackMessage("No data available to download.");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    const exportData = data.map((item, index) => ({
      "Sl No": index + 1,
      "Name": item.name || "--",
      "Email": item.email || "--",
      "User Type": item.user_type || "--",
      "IP Address": item.ip_address || "--",
      "Device": item.device_type || "--",
      "Browser": item.browser || "--",
      "Status": item.status || "--",
      "Time": item.logged_in_at ? moment(item.logged_in_at).format("DD-MMM-YYYY hh:mm A") : "--",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Login Logs");
    XLSX.writeFile(workbook, "Login_Logs.xlsx");
  };

  return (
    <div className="container-fluid mt-4">
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="card shadow-sm">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
          <h5 className="mb-0"><b>Login Activity Logs</b></h5>
          <div className="d-flex gap-2">
            <button className="btn btn-primary btn-sm" onClick={downloadExcel}>
              Download Excel
            </button>
            <button
              className={`filter-icon-btn ${showFilters ? "active" : ""}`}
              onClick={() => setShowFilters(!showFilters)}
              title="Toggle Filters"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
              </svg>
            </button>
          </div>
        </div>

        <div className="card-body pt-0">
          <div className={`filter-container ${showFilters ? "show" : ""}`}>
            <div className="row align-items-end">
              <div className="col-md-3">
                <label className="form-label small text-uppercase">Search</label>
                <input
                  type="text"
                  name="search"
                  className="form-control filter-control"
                  placeholder="Email, Name, IP..."
                  value={filters.search}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label small text-uppercase">User Type</label>
                <select
                  name="user_type"
                  className="form-control filter-control"
                  value={filters.user_type}
                  onChange={handleFilterChange}
                >
                  <option value="">All Types</option>
                  <option value="user">User</option>
                  <option value="admin">Admin</option>
                  <option value="company_sub_user">Sub User</option>
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label small text-uppercase">Status</label>
                <select
                  name="status"
                  className="form-control filter-control"
                  value={filters.status}
                  onChange={handleFilterChange}
                >
                  <option value="">All Statuses</option>
                  <option value="success">Success</option>
                  <option value="failed">Failed</option>
                </select>
              </div>
              <div className="col-md-3 d-flex gap-2">
                <button
                  className="filter-action-btn"
                  title="Reset Filters"
                  onClick={() => {
                    setFilters({
                      search: "",
                      status: "",
                      user_type: "",
                    });
                    setPage(1);
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                    <path d="M3 3v5h5"></path>
                  </svg>
                </button>
                <button
                  className="filter-action-btn close-btn"
                  title="Close Filters"
                  onClick={() => setShowFilters(false)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <CustomTable
            {...props}
            columns={[
              { title: "Sl No", field: "slno", width: "70px" },
              {
                title: "User Details", field: "name", render: (row) => (
                  <div>
                    <div className="fw-bold">{row.name}</div>
                    <div className="text-muted small">{row.email}</div>
                  </div>
                )
              },
              { title: "Type", field: "user_type", render: (row) => <span className="text-capitalize">{row.user_type?.replace(/_/g, ' ')}</span> },
              { title: "IP Address", field: "ip_address" },
              {
                title: "Platform", field: "device_type", render: (row) => (
                  <span className="text-capitalize small">
                    {row.device_type} / {row.browser}
                  </span>
                )
              },
              {
                title: "Status",
                field: "status",
                render: (row) => {
                  const statusInfo = getStatusInfo(row.status);
                  return (
                    <span className={`status-badge ${statusInfo.class}`}>
                      <span className="status-icon">{statusInfo.icon}</span>
                      <span className="status-label">{statusInfo.label}</span>
                    </span>
                  );
                },
              },
              {
                title: "Logged At",
                field: "logged_in_at",
                render: (row) => row.logged_in_at ? moment(row.logged_in_at).format("DD-MMM-YYYY hh:mm A") : "--",
              },
              {
                title: "Action",
                render: (row) => (
                  <div className="d-flex gap-1">
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => handleView(row)}
                    >
                      View
                    </button>
                  </div>
                ),
              },
            ]}
            data={data}
            paging={false}
          />

          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="flex-grow-1"></div>
            <div className="btn-group">
              <button
                className="btn btn-sm btn-outline-primary"
                disabled={page === 1}
                onClick={() => setPage((p) => p - 1)}
              >
                Prev
              </button>
              {renderPagination()}
              <button
                className="btn btn-sm btn-outline-primary"
                disabled={page === totalPages}
                onClick={() => setPage((p) => p + 1)}
              >
                Next
              </button>
            </div>
            <div className="flex-grow-1 d-flex justify-content-end">
              <select
                className="form-control form-control-sm w-auto ml-2"
                value={perPage}
                onChange={handlePerPageChange}
                style={{ fontSize: "8px", height: "31px" }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
